import { APIs } from "../utils/worker";

// API Configuration
export const API_CONFIG = {
  TRACKING_BASE_URL: APIs.trackingURL,
  
  // Endpoints
  ENDPOINTS: {
    GENERATE_OTP: "/generateOTP",
    VERIFY_OTP: "/verifyOTP"
  }
};

// Helper functions
export const getTrackingUrl = (awbNumber) => 
  `${API_CONFIG.TRACKING_BASE_URL}/${awbNumber}`;

export const getGenerateOtpUrl = (mobileNumber) => 
  `${API_CONFIG.TRACKING_BASE_URL}${API_CONFIG.ENDPOINTS.GENERATE_OTP}/${mobileNumber}`;

export const getVerifyOtpUrl = () => 
  `${API_CONFIG.TRACKING_BASE_URL}${API_CONFIG.ENDPOINTS.VERIFY_OTP}`;
